const { DataServiceEndPoint } = require("@cloudbreakus/network-utilities")
const { toLoggableIntakeAnswers } = require("../../utils/redaction")

class IntakeQuestions extends DataServiceEndPoint {
  static key = "IntakeQuestions"

  getForInteractionId = async ({ interactionId }) => {
    if (!interactionId) {
      this._logger.debug("[DATA] No interactionId provided to getForInteractionId, returning empty.")
      return { data: [] }
    }
    const url = `${this.url}/v1/interactions/${interactionId}/intake-questions`
    const headers = { Authorization: `bearer ${this.token}` }
    try {
      const result = await this._httpService.get(url, { headers })
      const questions = result?.data || []
      this._logger.debug(`[DATA] Intake Questions fetched from API for interaction ${interactionId}`, { questions, raw: result })
      return { data: questions }
    } catch (error) {
      this._logger.error(`[DATA] Failed to fetch Intake Questions from API for interaction ${interactionId}`, error)
      throw error
    }
  }


  upsertAnswers = async ({ interactionId, answers }) => {
    const url = `${this.url}/v1/interactions/${interactionId}/intake-answers`
    const headers = { Authorization: `bearer ${this.token}` }
    const mode = this._config.get("callsheet.intakeAnswer") || "new"
    const payload = { answers, mode }

    return await this._httpService.put(url, payload, { headers })
  }

  getAnswers = async ({ interactionId }) => {
    const query = `
      query GetIntakeAnswers($interactionId: uuid!) {
        intakeAnswers(where: { interactionId: { _eq: $interactionId } }) {
          questionId
          answer
          intakeQuestion {
            title
            itemType
          }
        }
      }
    `
    const data = { interactionId }
    const result = await this._hasuraService.query({ query, data })
    const answers = result?.data?.intakeAnswers || []
    const answersMap = {}

    answers.forEach((item) => {
      answersMap[item.questionId] = item.answer
    })

    this._logger.debug("[DATA] Intake Answers fetched with question details", toLoggableIntakeAnswers(answers))

    return { data: answersMap }
  }
}

module.exports = IntakeQuestions
